import React from "react";
import { useDispatch } from "react-redux";
import { Table, Button, Modal, notification } from "antd";
import { Tag } from "antd";
import { columns } from "./data";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { call } from "@/actions/axios";
import { REMOVE_APP_BY_PARAM } from "@/actions/app";

const { confirm } = Modal;

const TableComp = (props) => {
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 20,
    pageSizeOptions: [20, 50, 100],
  });

  const [filters, setFilters] = React.useState(null);

  const [sorter, setSorter] = React.useState(null);

  const onChange = (pagination, filters, sorter) => {
    setPagination(pagination);
    setFilters(filters);
    if (false) setSorter({ [sorter.field]: sorter.order });
  };

  const dispatch = useDispatch();

  const onDelete = (id) => {
    confirm({
      title: "Внимание!",
      icon: <ExclamationCircleOutlined />,
      content: "Вы действительно хотите удалить список?",
      okText: "Да",
      async onOk() {
        try {
          await dispatch(
            call({
              url: `/targetlist/data/${id}`,
              method: "DELETE",
            })
          );
          dispatch(REMOVE_APP_BY_PARAM(["lists"], "id", id));
        } catch (e) {
          return notification.info({
            message: "Ошибка!",
            description: "Не удалось удалить список",
          });
        }
      },
      onCancel() {},
    });
  };

  const options = {
    campaign_id: {
      render: (val) => {
        if (val) return <Tag color="success">Закреплен к кампании</Tag>;
        else return <Tag color="default">Не закреплен к кампании</Tag>;
      },
    },
    actions: {
      render: (_, item) => {
        return (
          <div className="actions">
            <Button
              onClick={() => onDelete(item.id)}
              size="small"
              disabled={!!item.campaign_id}
              type="action_delete"
            >
              <DeleteOutlined />
            </Button>
          </div>
        );
      },
    },
  };

  return (
    <Table
      size="small"
      className="striped-table"
      columns={columns(options, filters, sorter)}
      rowKey={(row) => row.id}
      {...props}
      pagination={pagination}
      onChange={onChange}
    />
  );
};

export default TableComp;
